export default __webpack_public_path__ + "static/media/ic_folder.8bbc5f3f.svg";